// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"302":"swiggy_mxn_render","335":"lottie-web","570":"dine_cash_pooling"}[chunkId] + "." + {"302":"683dd3e2b343dd923d63","335":"c8d48889b30084413518","570":"9dddc0bdae0500bd7e2b"}[chunkId] + ".js";
};